import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';

import type { ISelectSingleValueProps } from './SelectOptions.types';
import type { IFieldOptionData } from './SelectOptions.utils';
import { getFieldDataTypeIcon } from './SelectOptions.utils';
import SelectSingleValue from './SelectSingleValue';

import * as styles from './SelectOptions.css';

export function FieldSingleValue<T extends IFieldOptionData>(
  props: Readonly<ISelectSingleValueProps<T>>,
): JSX.Element {
  const { data } = props;
  const icon = getFieldDataTypeIcon(data);

  return (
    <SelectSingleValue {...props}>
      <div className={styles.fieldOption}>
        <div className={styles.contentWrapper}>{icon && <FontAwesomeIcon icon={icon} />}</div>
        <div className={styles.fieldOptionCell}>
          <span>{data.key || data.name || data.label || data.u_key}</span>
        </div>
      </div>
    </SelectSingleValue>
  );
}
